import { FormattedAssignment } from 'modules/finance/lib/costCenterAssignments'

import { DEFAULT_ASSIGNMENT_COST_CENTER_ID, DEFAULT_ASSIGNMENT_PERCENTAGE } from './defaults'

export const totalDedication = (assignments: FormattedAssignment[]) => {
  return (
    assignments.reduce(
      (acc, cur) => acc + (cur.percentage === DEFAULT_ASSIGNMENT_PERCENTAGE ? 0 : cur.percentage),
      0
    ) * 100
  ).toFixed(2)
}

export const validDedication = (assignments: FormattedAssignment[]) => {
  return totalDedication(assignments) === '100.00'
}

export const hasZeroDedication = (assignments: FormattedAssignment[]) => {
  return !!assignments.find(
    (a) => a.percentage === 0 || a.percentage === DEFAULT_ASSIGNMENT_PERCENTAGE
  )
}

export const hasUnassignedCostCenter = (assignments: FormattedAssignment[]) => {
  return !!assignments.find((a) => a.costCenterId <= DEFAULT_ASSIGNMENT_COST_CENTER_ID)
}
